import React from "react";
import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineDownload } from "react-icons/ai";
const ActionSelectorOld = ({
  busy,
  selectedOption,
  setSelectedOption,
  onAction,
   actionName="Perform Action",
   fromNO, setFromNo,
  toNo, setToNo
}) => {
  return (
    <>
    <div className="flex justify-center items-center text-xs p-2">
      {/* Action Button */}
      <button
        onClick={onAction}
        disabled={busy}
        className={`h-9 flex items-center gap-2 px-4 rounded-l-lg rounded-r-none transition duration-200 
          ${busy
            ? "bg-yellow-300 text-gray-900 cursor-not-allowed"
            : "bg-blue-200 text-gray-900 hover:bg-blue-700 hover:text-white"}
        `}
      >
        <AiOutlineDownload size={20} />
        {busy ? (
          <div className="flex items-center space-x-1">
            <span>Please wait</span>
            <span className="flex space-x-1">
              <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot1" />
              <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot2" />
              <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot3" />
            </span>
          </div>
        ) : (
         actionName
        )}
      </button>

      {/* Select Dropdown */}
      <select
        value={selectedOption}
        disabled={busy}
        onChange={(e) => setSelectedOption(e.target.value)}
        className={`h-9 border border-gray-400 border-l-0 rounded-r-lg rounded-l-none px-2 text-gray-800 focus:outline-none focus:ring-1 focus:ring-blue-500
          ${busy
            ? "bg-yellow-300 text-gray-900 cursor-not-allowed"
            : "bg-blue-200 text-gray-900 hover:bg-blue-700 hover:text-white"}
        `}
      >
        <option value="yes">Head-Yes</option>
        <option value="no">Head-No</option>
      </select>
    </div>
    <div className="flex gap-4 bg-blue-200 p-4">
<div className="flex flex-col">
      <label>From</label>
      <input></input>
    </div>
    <div className="flex flex-col">
      <label>To</label>
      <input></input>
    </div>
    </div>
    
    </>

  );
};


const ActionSelector = ({
  busy,
  selectedOption,
  setSelectedOption,
  onAction,
  actionName = "Perform Action",
  fromNo, setFromNo,
  toNo, setToNo,
}) => {
  return (
    <>
      {/* Action Button and Select Dropdown */}
      <div className="flex justify-center items-center text-xs p-2 mt-6">
        <button
          onClick={onAction}
          disabled={busy}
          className={`h-9 flex items-center gap-2 px-4 rounded-l-lg rounded-r-none transition duration-200 
            ${
              busy
                ? "bg-yellow-300 text-gray-900 cursor-not-allowed"
                : "bg-blue-200 text-gray-900 hover:bg-blue-700 hover:text-white"
            }
          `}
        >
          <AiOutlineDownload size={20} />
          {busy ? (
            <div className="flex items-center space-x-1">
              <span>Please wait</span>
              <span className="flex space-x-1">
                <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot1" />
                <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot2" />
                <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot3" />
              </span>
            </div>
          ) : (
            actionName
          )}
        </button>

        <select
          value={selectedOption}
          disabled={busy}
          onChange={(e) => setSelectedOption(e.target.value)}
          className={`h-9 border border-gray-400 border-l-0 rounded-r-lg rounded-l-none px-2 text-gray-800 focus:outline-none focus:ring-1 focus:ring-blue-500
            ${
              busy
                ? "bg-yellow-300 text-gray-900 cursor-not-allowed"
                : "bg-blue-200 text-gray-900 hover:bg-blue-700 hover:text-white"
            }
          `}
        >
          <option value="yes">Head-Yes</option>
          <option value="no">Head-No</option>
        </select>
      </div>

      {/* From / To Inputs */}
      <div className="flex gap-4 bg-blue-200 p-4 text-sm">
        <div className="flex flex-col">
          <label className="font-medium mb-1">From</label>
          <input
            type="text"
            value={fromNo}
            onChange={(e) => setFromNo(e.target.value)}
            className="border border-gray-400 rounded-lg px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
            disabled={busy}
          />
        </div>

        <div className="flex flex-col">
          <label className="font-medium mb-1">Max To</label>
          <input
            type="text"
            value={toNo}
            onChange={(e) => setToNo(e.target.value)}
            className="border border-gray-400 rounded-lg px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
            disabled={busy}
          />
        </div>
      </div>
    </>
  );
};



const Course = ({ course, session ,downloadAllGradeCards,downloadMeritList,downloadAllGradeCardsOfAllStudents}) => {
  const navigate = useNavigate();
const [busy, setBusy] = useState(false);
const [busyML, setBusyML] = useState(false);
const [busyAllGradeCards, setBusyAllGradeCards] = useState(false);
 const [bgAllStudentAllGradeCards, setBgAllStudentAllGradeCards] = useState("yes");
  const [bgAllStudentConsolidatedGC, setBgAllStudentConsolidatedGC] = useState("yes");
 const [fromNo, setFromNo] = useState("1");
  const [toNo, setToNo] = useState("100");
const [fromNo2, setFromNo2] = useState("1");
  const [toNo2, setToNo2] = useState("100");

  const handleCardClick = (semester) => {
    const mainElement = document.querySelector("main"); // Target <main> directly
    if (mainElement) {
        sessionStorage.setItem("scrollPosition", mainElement.scrollTop); // Save scroll position
        //alert(`Saved Scroll Position: ${mainElement.scrollTop}`);

    }
    navigate(`/resultdeclarationform/${course.batch}/${session}/${semester}`);
};

const handleDownload = async (e) => {
   alert(fromNo2+" "+toNo2);
  setBusy(true);
  try {
    await downloadAllGradeCards(e,  bgAllStudentConsolidatedGC.toLocaleLowerCase(), session, course.batch,fromNo2,toNo2);
  } catch (err) {
    console.error("Download failed:", err);
  } finally {
    setBusy(false);
  }
};

const handleDownloadML = async (e) => {
  setBusyML(true);
  try {
    await downloadMeritList(e, 'yes', session, course.batch);
  } catch (err) {
    console.error("Download failed:", err);
  } finally {
    setBusyML(false);
  }
};
const handleDownloadAllGradeCardsOfAllStudents = async (e) => {
  //alert(bgAllStudentAllGradeCards);
   alert(fromNo+" "+toNo);
  setBusyAllGradeCards(true);
  try {
    await downloadAllGradeCardsOfAllStudents(e, bgAllStudentAllGradeCards.toLocaleLowerCase(), session, course.batch,fromNo,toNo);
  } catch (err) {
    console.error("Download failed:", err);
  } finally {
    setBusyAllGradeCards(false);
  }
};
  return (
    <div      
      className="w-full bg-gray-100 rounded-xl px-4 py-2 flex flex-col justify-center  transition-shadow duration-300 
          text-gray-800 "
      >
      <p className="w-full text-xs text-center font-semibold mb-2">{course.batch}</p>
      <p className="w-full text-sm text-center mb-2 font-semibold ">
        {course.noOfStudents} <span className="text-xs">STUDENTS</span>
      </p>
      <div className="flex flex-col justify-center items-center ">
<ActionSelector
  busy={busyAllGradeCards}
  selectedOption={bgAllStudentAllGradeCards}
  setSelectedOption={setBgAllStudentAllGradeCards}
  onAction={handleDownloadAllGradeCardsOfAllStudents}
  actionName="All GradeCards Of All Students"  
    fromNo={fromNo}
     setFromNo={setFromNo}
     toNo={toNo}
     setToNo={setToNo}
/>

       {false &&<div className="flex justify-center items-center mb-3 bg-red-300 text-xs p-2">
  <button
    onClick={handleDownloadAllGradeCardsOfAllStudents}
    disabled={busyAllGradeCards}
    className={`h-9 flex items-center gap-2 px-4 rounded-l-lg rounded-r-none transition duration-200 
      ${busyAllGradeCards 
        ? 'bg-yellow-300 text-gray-900 cursor-not-allowed' 
        : 'bg-blue-200 text-gray-900 hover:bg-blue-700 hover:text-white'}
    `}
  >
    <AiOutlineDownload size={20} />
    {busyAllGradeCards ? (
      <div className="flex items-center space-x-1">
        <span>Please wait</span>
        <span className="flex space-x-1">
          <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot1" />
          <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot2" />
          <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot3" />
        </span>
      </div>
    ) : (
      "All Gradecards All Students"
    )}
  </button>

  <select
  value={bgAllStudentAllGradeCards}
  disabled={busyAllGradeCards}
  onChange={(e) => setBgAllStudentAllGradeCards(e.target.value)}
  className={`h-9 border border-gray-400 border-l-0 rounded-r-lg rounded-l-none px-2 text-gray-800 focus:outline-none focus:ring-1 focus:ring-blue-500
    ${busyAllGradeCards 
      ? 'bg-yellow-300 text-gray-900 cursor-not-allowed' 
      : 'bg-blue-200 text-gray-900 hover:bg-blue-700 hover:text-white'}
  `}
>
  <option value="BG">BG</option>
  <option value="BARE">BARE</option>
</select>
</div>}


<ActionSelector
  busy={busy}
  selectedOption={bgAllStudentConsolidatedGC}
  setSelectedOption={setBgAllStudentConsolidatedGC}
  onAction={handleDownload}
  actionName="All Students Consolidated Gradecards"
   fromNo={fromNo2}
     setFromNo={setFromNo2}
     toNo={toNo2}
     setToNo={setToNo2}
/>
      {false &&<div className=" text-xs flex justify-center items-center mb-3">
        <button
  onClick={handleDownload}
  disabled={busy}
  className={`w-[220px] text-xs flex items-center gap-2 px-4 py-2 rounded-lg transition duration-200 
   ${busy 
      ? 'bg-yellow-300 text-gray-900 cursor-not-allowed' 
      : 'bg-blue-200 text-gray-900 hover:bg-blue-700 hover:text-white'}
  `}
>
  <AiOutlineDownload size={20} />
  {busy ? (
    <div className="flex items-center space-x-1">
      <span>Please wait</span>
      <span className="flex space-x-1">
        <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot1" />
        <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot2" />
        <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot3" />
      </span>
    </div>
  ) : (
    "Consolidated Gradecards"
  )}
</button>

      </div>}

<div className=" text-xs flex justify-center items-center mb-3 mt-6">
        <button
  onClick={handleDownloadML}
  disabled={busyML}
  className={`w-[220px] text-xs flex items-center gap-2 px-4 py-2 rounded-lg transition duration-200 
   ${busyML 
      ? 'bg-yellow-300 text-gray-900 cursor-not-allowed' 
      : 'bg-blue-200 text-gray-900 hover:bg-blue-700 hover:text-white'}
  `}
>
  <AiOutlineDownload size={20} />
  {busyML ? (
    <div className="flex items-center space-x-1">
      <span>Please wait</span>
      <span className="flex space-x-1">
        <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot1" />
        <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot2" />
        <span className="w-1.5 h-1.5 bg-gray-800 rounded-full animate-bounceDot3" />
      </span>
    </div>
  ) : (
    "MERIT LIST"
  )}
</button>

      </div>
      
      </div>

      {/* Semester-wise Cards */}
      <div className="flex flex-wrap justify-center gap-2">
        {course.semesterArray.map((sm, index) => (
          <div
            key={index}
            className={
              `w-24 h-24 bg-white cursor-pointer shadow-md rounded-lg flex flex-col items-center justify-center text-gray-800 border border-gray-300
              ${
                sm.submission_status === "declared"
                  ? "bg-gradient-to-r from-green-300 to-green-200 hover:from-green-600 hover:to-green-400 text-black"
                  : "bg-gradient-to-r from-pink-300 to-pink-600 hover:from-pink-500 hover:to-pink-700 text-white"
              }
              `
            }
           onClick={() => handleCardClick(sm.semester)}
          >
            <p className="text-sm font-semibold">Sem {sm.semester}</p>
            <p className="text-xs text-gray-600 font-semibold">{sm.noOfStudents} students</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Course;
